import React, { useState } from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  FormHelperText,
} from "@chakra-ui/react";
import Star from "./RatingStar/Star";
import "./RatingStar/Styles.css";

const Rating = ({ options, formik, id }) => {
  const styleClasses =
    options.styleClasses && options.styleClasses.length
      ? options.styleClasses.join(" ")
      : "";
  const ratingErrors =
    Object.keys(formik.errors).length &&
    formik.errors.rating &&
    formik.errors.rating.length &&
    formik.errors.rating[id];
  const ratingTouched =
    Object.keys(formik.touched).length &&
    formik.touched.rating &&
    formik.touched.rating.length &&
    formik.touched.rating[id];
  const hasError = ratingTouched && ratingErrors;
  // const styleClasses = options.styleClasses.length
  //   ? options.styleClasses.join(" ")
  //   : "";
  //const hasError = formik.touched.rating && formik.errors.rating;

  const [gradeIndex, setGradeIndex] = useState();
  const activeStar = { fill: options.ratingColor };
  const changeGradeIndex = (index) => {
    if (index == 0) {
      index++;
    } else {
      index++;
    }
    setGradeIndex(index);
    const setValues = formik.setValues;
    const formikValues = formik.values;
    const rating = [...formik.values.rating];
    const currentValues = index;
    let newUpdateValue = true;
    Object.keys(formikValues.rating).some((field, i) => {
      Object.keys(formikValues.rating[i]) == `rating.${id}.${options.label}` &&
        (formikValues.rating[i][`rating.${id}.${options.label}`] = index);
      if (
        formikValues.rating.length - 1 == i &&
        Object.keys(formikValues.rating[i]) == `rating.${id}.${options.label}`
      ) {
        newUpdateValue = false;
      }
      if (!newUpdateValue) {
        return;
      }
    });
    if (newUpdateValue) {
      const currentValuesWithId = {
        [`rating.${id}.${options.label}`]: currentValues,
      };
      rating.push(currentValuesWithId);
    }
    setValues({ ...formikValues, rating });
  };

  return (
    <FormControl
      className={styleClasses}
      isInvalid={hasError ? true : false}
      mb="2"
      isRequired={options.isRequired}
    >
      {options.showLabel && (
        <FormLabel htmlFor="rating" fontSize="14px">
          {options.label}
        </FormLabel>
      )}
      <div className="stars">
        {[...Array(+options.ratingScale)].map((grade, index) => (
          <Star
            index={index}
            key={index}
            changeGradeIndex={changeGradeIndex}
            style={gradeIndex > index ? activeStar : {}}
          />
        ))}
      </div>
      <FormHelperText>{options.helpText}</FormHelperText>
      {hasError ? (
        <FormErrorMessage>{formik.errors.rating}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};

export default Rating;
